export class BankChart {
  constructor(objInit) {
    this.localCredit = objInit.localCredit;
    this.localDebit = objInit.localDebit;
    this.dateParts = objInit.dateParts;
  }
}
